import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from './about.component';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AboutService } from '../services/about.service';

@NgModule({
	imports: [
        CommonModule,
        MatListModule,
		MatDividerModule,
		MatFormFieldModule,
		MatButtonModule,
		MatIconModule,
		MatDialogModule,
		ClipboardModule,
	],
	declarations: [
		AboutComponent,
	],
	exports: [
		AboutComponent
	],
	providers: [
		AboutService,
	]
})
export class AboutModule { 

}